/**
 * Enum for aria-hidden attribute values.
 */
export enum AriaHidden {
  True = 'true',
  False = 'false',
}
